<template>
  <div class="tree-container" v-height="{offsetHeight:300}">
    <Input type="text" v-model="searchword" class="select-search"
           @on-change="searchNodes" clearable placeholder="搜索" >
      <Icon type="ios-search" slot="prepend"></Icon>
    </Input>
    <v-tree ref='paasTree'
          :data='treeData'
          @node-click="clickTreeNode"
            @node-check="checkTreeNode"
            :multiple="multiple"
            v-height="{offsetHeight:340}"/>
  </div>
</template>

<script>
  import { getTreeData } from "@api/admin.js";
    export default {
      name: "selectTree",
      props:{
        value: {
          type: [String, Number],
          default: ''
        },
        serviceUrl:{
          type: String,  //后台controller路径
        },
        multiple:{
          type:Boolean,
        }
      },
      data(){
        return{
          currentValue:[this.value],
          treeData:[],
          searchword:'',
        }
      },
      created(){
        this.queryTreeDatas();
      },
      methods:{
        /**
         * 获取树的数据
         */
        queryTreeDatas() {
          getTreeData(this.serviceUrl,{}).then(res => {
            if(res.code === 200) {
              /**
               * 1、获取树的数据
               */
              this.treeData = res.data;
              /**
               * 2、如若treeData数组只有一个，展开一级节点；若treeData数组多个，则不展开
               */
              if(this.treeData.length === 1){
                this.treeData[0].expanded = true;
              }
            }
          }).catch(error => {
            this.$Message.info("数据刷新失败")
          });
        },
        /**
         * 点击树节点
         * @param node
         */
        clickTreeNode(node){
          /**
           * 给引用的input赋值
           */
          this.$emit("selected-tree-value",node);
        },
        /**
         * 选中节点
         * @param node
         */
        checkTreeNode(node){
          this.$emit("check-tree-value",node);
        },
        searchNodes(){
          this.$refs.paasTree.searchNodes(this.searchword);
        },
        setTreeCheckedStatu(id,status){
          this.$refs.paasTree.setTreeNodeAttrById(this.treeData,id,"checked",status);
        }
      },
      watch: {
        value (val) {
          this.currentValue = val;
        }
      },
    }
</script>

<style scoped>
.tree-container{
  background:#ffffff;
  position:absolute;
  z-index: 100000;
  overflow: auto;
}
.tree-container >>> .ivu-input{
  margin-left:-10px;
}
.tree-container >>> .search-input, .tag {
  border: none;
}
.tree-container >>> .halo-tree{
  overflow: auto;
  padding-left: 20px;
}
.select-search{
  height: 32px;
  width: 96%;
  margin: 2% auto;
}
.select-search >>> .ivu-input-group-prepend{
  width: 45px;
  padding: 0px 10px 0px 0px;
}
</style>
